<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import {computed, ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import GUIActionResult = namaTypes.GUIActionResult;
import NaMaText = namaTypes.NaMaText;

const {tasks} = storeToRefs(useLoginInfoStore());
const props = defineProps<{ pendingResponseId: string; }>()
const result = ref<GUIActionResult>(tasks.value?.find(l => l.pendingResponseId === props.pendingResponseId) ?? {});
const progress = ref(0);
const progressTotal = ref(100);
const progressLabel = computed(() => (progress.value * 100).toFixed(2) + '%');
const titleRef = ref<NaMaText>(result.value.progressTitle ?? (result.value?.resultTitle ?? {}));

function calcProgress() {
  progressTotal.value = result.value?.progressTotal ?? progressTotal.value;
  progress.value = result.value?.progressCurrent ? result.value.progressCurrent / progressTotal.value : progress.value;
}

watch(() => tasks.value, () => {
  result.value = tasks.value?.find(l => l.pendingResponseId === props.pendingResponseId) ?? {};
  titleRef.value = result.value?.progressTitle ?? (result.value?.resultTitle ?? {});
  calcProgress();
})

defineExpose({result});
</script>

<template>
  <q-card-section class="tw-p-0 tw-flex tw-flex-col tw-items-center tw-text-primary-light dark:tw-text-primary-dark tw-w-full">
    <div class="tw-flex tw-gab-2 tw-items-center tw-w-[95%] tw-text-sm">
      <NamaIcon :constant="result.iconConstant" default-icon="description" class="tw-size-7 !tw-text-7	tw-pr-2"/>
      <span v-text="Translator.translateNaMaText(titleRef)"/>
    </div>
    <div v-if="result.processing" class="tw-w-full tw-items-center">
      <div v-if="progress" class="tw-w-full tw-text-start tw-p-3 tw-flex tw-flex-row tw-gap-4 tw-items-center">
        <q-linear-progress :value="progress" color="primary" size="6px" class="tw-rounded-full"/>
        <span v-text="progressLabel" class="tw-text-namaFontColor-light dark:tw-text-namaFontColor-dark"/>
      </div>
      <div v-else>
        <q-spinner-hourglass color="primary" size="2em" class="tw-m-4"/>
      </div>
    </div>
  </q-card-section>
</template>

<style scoped>

</style>
